module.exports = "/images/no-protection.png?59cb36d1cd1afd6ff8f63e28fb789086";